<script setup>
defineProps(['alertTrigger'])
</script>

<template>
  <div v-if="alertTrigger" class="bg-red-600 px-4 py-2" role="alert">
    <span class="text-white font-normal">
      <slot></slot>
    </span>
  </div>
</template>

<style scoped></style>
